/**
 * @generated SignedSource<<69a52b493267358e3d3494d21178da4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteText_page$data = {
  readonly currentValue: string;
  readonly " $fragmentSpreads": FragmentRefs<"useNoteWidgetStyleText_widgetNotePage">;
  readonly " $fragmentType": "WidgetNoteText_page";
};
export type WidgetNoteText_page$key = {
  readonly " $data"?: WidgetNoteText_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNoteText_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNoteText_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentValue",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNoteWidgetStyleText_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "52a849b5ebd4a89f4ecd27838be866e0";

export default node;
